import { requestPublicKey } from "@shared/api/external";

export const getPublicKey = () => requestPublicKey();
